export const initHeaderSearchApp = () => {
    if (document.getElementById('js-nav-search')){
        import(/* webpackChunkName: "trl-ns" */ './main')
            .then((module) => {
                module.initApp();
            })
    }
}
